import { Link } from "react-router-dom"
import { toSalusionPrivate } from "../../util"
import referral from "../../assets/referral.svg"

export default function Hero() {
	return (
		<section className="first-section first-padding" id="hero">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-12 col-md-6">
						<div className="hero-content">
							<h1>Add HRAs to Your Offering</h1>
							<p>Stay broker of record for insurance enrollment</p>

							{/* <Link className="btn-linear" onClick={(event) => toSalusionPrivate(event, "/create-account", false)}> */}

							<Link
								className="btn-linear"
								onClick={(event) => toSalusionPrivate(event, "/create-partner-account", false)}
							>
								Become A Partner
							</Link>
						</div>
					</div>

					<div className="col-12 col-md-6">
						<img src={referral} alt="salusion logo" />
					</div>
				</div>
			</div>
		</section>
	)
}
